import { render } from "./EditView.vue?vue&type=template&id=2ee24545"
import script from "./EditView.vue?vue&type=script&lang=js"
export * from "./EditView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__